import { render, staticRenderFns } from "./CashierSummary.vue?vue&type=template&id=01fc6001"
import script from "./CashierSummary.vue?vue&type=script&lang=js"
export * from "./CashierSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports